const formatters = new Map<string, Intl.NumberFormat>();

function formatterFor(currency: string): Intl.NumberFormat {
  const existing = formatters.get(currency);
  if (existing) return existing;
  const formatter = new Intl.NumberFormat("en-GB", {
    style: "currency",
    currency,
    maximumFractionDigits: 0,
  });
  formatters.set(currency, formatter);
  return formatter;
}

/** 249, "GBP" -> "£249". Falls back to a plain number if the currency code is invalid. */
export function formatMoney(amount: number, currency: string): string {
  try {
    return formatterFor(currency).format(amount);
  } catch {
    return `${currency} ${amount.toLocaleString()}`;
  }
}
